var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "#1D1D1B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7108 17.3998C16.249 17.3998 14.822 16.9548 13.6193 16.1241C12.4165 15.2934 11.4952 14.1163 10.9776 12.7493C10.46 11.3823 10.3708 9.89016 10.7218 8.47122C11.0727 7.05227 11.8473 5.77377 12.9424 4.80566C11.7892 4.84849 10.6632 5.16789 9.65923 5.73696C8.65527 6.30602 7.80282 7.10808 7.17371 8.07554C6.54459 9.04299 6.15725 10.1475 6.04432 11.296C5.93139 12.4445 6.09619 13.6033 6.52482 14.6747C6.95345 15.7462 7.63336 16.6989 8.50724 17.4526C9.38113 18.2063 10.4234 18.7389 11.5462 19.0056C12.669 19.2722 13.8394 19.265 14.9589 18.9846C16.0783 18.7042 17.1139 18.1589 17.9785 17.3945C17.8896 17.3972 17.8002 17.3998 17.7108 17.3998Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.db4772e3fb6740cfab696186a4326e9d.svg";
export { ForwardRef as ReactComponent };